module.exports = __webpack_public_path__ + "media/images/menu-72c012076451ec39c3f6c33026d62f16.svg";